export default __webpack_public_path__ + "static/media/project4.3a86cb0f.PNG";